import React from 'react'
import PropTypes from 'prop-types';
import { WarningPanel } from '~/views';

export default class ProjectError extends React.Component {

  static propTypes = {
  }

  render() {
    const title = 'Oh Sprockets!'// Random.value( ["Oh Sprockets!", "Rivets and Bolts!"] );
    return ( 
      <WarningPanel
        title={title} 
        code={this.props.statusCode} 
        subtitle={this.props.subtitle || 'I failed to load that project page'}
        message={this.props.message} />
    )
  }

}
